import * as types from './action_types';
import DateMaster from '../utils/date_master';
import TackNotificationsService from '../../services/tack_notifications_service';

export const tackNotifications = () => {
  return async(dispatch) => {
    try {
      dispatch({ type: types.TACK_NOTIFICATIONS_RETRIEVING });
      const tackNotificationsData = await TackNotificationsService.tackNotifications();
      const tackNotifications = []
      for (let tackNotification of tackNotificationsData) {
        tackNotifications.push({
          slug: tackNotification.slug,
          wordText: tackNotification.word_text,
          deliveryMethod: tackNotification.delivery_method,
          tackInterval: tackNotification.tack_interval,
          day: tackNotification.day,
          isCheckpoint: tackNotification.is_checkpoint,
          isArchive: tackNotification.is_archive,
          isChat: tackNotification.is_chat,
          readAt: DateMaster.parseUTC(tackNotification.read_at),
          createdAt: DateMaster.parseUTC(tackNotification.created_at),
          lastSentDate: DateMaster.parseUTC(tackNotification.last_sent_date)
        });
      }
      dispatch({ type: types.TACK_NOTIFICATIONS_RETRIEVED, tackNotifications });
    } catch(error) {
      dispatch({ type: types.TACK_NOTIFICATIONS_ERROR, error });
    }
  }
}

export const unreadCount = () => {
  return async(dispatch) => {
    try {
      const unreadCountData = await TackNotificationsService.unreadCount();
      const unreadTackNotificationsCount = unreadCountData.unread_tack_notifications_count;
      dispatch({ type: types.TACK_NOTIFICATIONS_UNREAD_COUNT_RETRIEVED, unreadTackNotificationsCount });
    } catch(error) {
      dispatch({ type: types.TACK_NOTIFICATIONS_ERROR, error });
    }
  }
}



// WEBPACK FOOTER //
// ./src/stores/tack_notifications/actions.js